SupportMainContentWrapperView = require('../../main_content_view')
StepTwoCMSBaseView = require('./base_view')
Mustache = require('../../../../../../core/frontend/vendor_modules/mustache-0.7.2')

class StepTwoV1CMSView extends StepTwoCMSBaseView
  initialize: ->
    StepTwoCMSBaseView::initialize.apply(this, arguments)

  render: ->
    StepTwoCMSBaseView::render.call(this)
    mainContentWrappper = new SupportMainContentWrapperView
    mainContentWrappper.render( (contentWrapper) =>
      @renderProgressBar(contentWrapper)
      @renderOrderInfo(contentWrapper)
      @fetchFlexibleContactChannels(contentWrapper)
      @fetchAndRenderCategory(contentWrapper)
    )
    @$el.append(mainContentWrappper.el)
    @renderStepTwoActions()
    @renderLiveChat(@$el)
    content = Groupon.Support.ContentModel.getContent()
    @renderContent(content) if content?

  renderContent : (content) ->
    unless content?.text? && content.text isnt ""
      @helpContentLoadError()
      @enableTicketDirectionButton()
      return
    text = Mustache.to_html(content.text, Groupon.Support.ContentModel.getContentObject())
    @$('.inbenta-content').html(text)

    if text? && @checkIfTextHasClickToContinueSubString(text)
      @enableTicketDirectionButton()
    else
      @enableResolvedButton()
    flexibleStepThree = Groupon.Support.ContentModel.flexibleStepThree
    if flexibleStepThree? && flexibleStepThree.method_of_contact == 'no_step_three'
      @hideContactUsButton()
    category_id = @getCategoryId()
    sub_category_id = @getSubCategoryId()
    @$('.inbenta-content').attr("data-bhw", "hw__#{country.name}__#{category_id}__#{sub_category_id}__#{content.id}")

  renderCategory: (contentWrapper)->
    @categoryRendered = true
    isFilterDropdowns = if window.evaluate(experiments?.filterDropdowns) then true else false
    contentWrapper.append toHtml(@categoryTemplate, {categories: @getCategoryList(), isFilterDropdowns:isFilterDropdowns}, @I18nScope)
    contentCategory = Groupon.Support.ContentModel.getCategory()
    if contentCategory && contentCategory != null
      $(".category", contentWrapper).val(contentCategory.id)
      # Adding single Quotes because the jquery selector erroring out if the id has punctuation in it
      $(".category option[value='#{contentCategory.id}']", contentWrapper).attr("selected", "selected")
      @renderSubCategory(contentWrapper)

  clearContentElement: ->
    @clearElement('.inbenta-content')

  clearStepThreeIfPresent: ->

  helpContentSuccess: (results) =>
    @spinnerView.hide()
    content = @resolveContent results
    Groupon.Support.ContentModel.flexibleStepThree = @resolveFlexStepThree results
    @setPriorityContentFlags results
    Groupon.Support.ContentModel.setContent(content)
    @renderContent(content)

  helpContentError: () =>
    Groupon.Support.ContentModel.flexibleStepThree = null
    Groupon.Support.ContentModel.setContent(null)
    @helpContentLoadError()
    @enableTicketDirectionButton()

module.exports = StepTwoV1CMSView
